/* eslint-disable */
import React from "react";
import { Skeleton } from "@material-ui/lab";
import { orderBy } from "lodash";
import { HierarchyControl, HierarchyControlItem } from '../../../../basf-ui';
import { CalendarHierarchy, InputCalendarHierarchyItem } from "../../../controls/CalendarHierarchy";
import { useDictionary, useParameter } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";
import { getDateWithoutFrequency, getDateId } from "../utils/dateHelpers";
import { MIN_DATE, SLIDE_NUMBER } from "../constants";

const YEAR_FREQUENCY = 1;

interface ControlItem extends HierarchyControlItem<number> {
  frequencyId: number;
}

export const CalendarControl: React.FC = () => {
  const [items, setItems] = React.useState<ControlItem[]>([]);
  const [loadingValue, setLoadingValue] = React.useState<boolean>(true);

  const [calendarValue, setCalendarValue] = useParameter<number[]>("@calendar");
  const [commodityValue] = useParameter<number | null>("@commodities");

  const [dictItems, _dictCalendar, loadingDictCalendar] = useDictionary(dictionaryService, "calendar-origin");
  const [dictItemsLastYear, _dictLastYear, loadingDictLastYear] = useDictionary(dictionaryService, "slides-f-last-calendar", undefined, {
    commodities: String(commodityValue),
    slide: SLIDE_NUMBER,
  });

  const dictItemsLastYearSorted = orderBy(dictItemsLastYear || [], (item) => item.getValue<number>("order"));
  const lastYearDate =
    dictItemsLastYearSorted && dictItemsLastYearSorted[0]
      ? Number(dictItemsLastYearSorted[0].id)
      : getDateId(new Date(), YEAR_FREQUENCY);

  React.useEffect(function updateControlItems() {
    setLoadingValue(true);
    if (dictItems) {
      const sortedDictItems = orderBy(dictItems, item => item.getValue<number>("order"));
      const candiatesControlItems = sortedDictItems.map<ControlItem>(dictItem => ({
        id: dictItem.getValue<number>('id')!,
        name: dictItem.getValue<string>("name")!,
        parent: dictItem.getValue<number>("parent"),
        frequencyId: dictItem.getValue<number>('frequencyId')!,
      }));

      const [minDate, maxDate] = [getDateWithoutFrequency(MIN_DATE), getDateWithoutFrequency(lastYearDate)];
      const datesInRengeLimit = (candiatesControlItems || []).filter((item) => {
        return (
          minDate <= getDateWithoutFrequency(item.id as number) && getDateWithoutFrequency(item.id as number) <= maxDate
        );
      });
      const nextControlItems: ControlItem[] = datesInRengeLimit.reduce((result, item) => {
        if (item.frequencyId === YEAR_FREQUENCY) {
          result.push(item);
        }
        return result;
      }, [] as ControlItem[]);

      setItems(nextControlItems);
      setLoadingValue(false);
    }
  }, [dictItems, lastYearDate]);

  const handlerChange = React.useCallback(
    (value: unknown) => {
      const weekOrMonthOrYearId = value as number;
      if (weekOrMonthOrYearId) {
        setCalendarValue([weekOrMonthOrYearId]);
      }
    },
    [dictItems, setCalendarValue],
  );

  const loading = loadingValue || loadingDictCalendar || loadingDictLastYear;
  return <HierarchyControl 
    label="Calendar"
    value={calendarValue?.[0]}
    onChange={handlerChange}
    items={items}
    loading={loading}
  />
};
